import { create } from 'zustand';

interface SubProcessParentState {
  parentRecordId: string | null;
  parentSourceId: string | null;
  diagramSourceId: string | null;
  set: (parentRecordId: string | null, parentSourceId: string | null) => void;
  setDiagramSourceId: (sourceId: string | null) => void;
  clear: () => void;
}

export const useSubProcessParentStore = create<SubProcessParentState>()((set) => ({
  parentRecordId: null,
  parentSourceId: null,
  diagramSourceId: null,
  set: (parentRecordId, parentSourceId) => set({ parentRecordId, parentSourceId }),
  setDiagramSourceId: (diagramSourceId) => set({ diagramSourceId }),
  clear: () => set({ parentRecordId: null, parentSourceId: null, diagramSourceId: null }),
}));
